module.exports = __webpack_public_path__ + "static/img/solutionPic6.c2db54f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/solutionPic6.png
// module id = bQr5
// module chunks = 1